import { render, staticRenderFns } from "./SignaturePad.vue?vue&type=template&id=2b7c0ac8"
import script from "./SignaturePad.vue?vue&type=script&setup=true&lang=js"
export * from "./SignaturePad.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports